import React from 'react';
import PropTypes from 'prop-types';
import WMMenuItem from '@workmarket/front-end-components/dist/WMMenuItem';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import styles from './styles';

const SupportMenuItems = ({ support, useZendesk }) => (
	<React.Fragment>
		<WMMenuItem
			className="app-social-menu-help-center"
			href="https://workmarket.zendesk.com/hc/en-us"
			primaryText="Help Center"
			style={ styles.item }
			target="_blank"
		/>
		<WMMenuItem
			className="app-social-menu-get-help"
			menuItems={ [
				!!useZendesk // eslint-disable-line no-extra-boolean-cast
					? <WMMenuItem
						className="app-social-menu-chat"
						id="menu-chat-button"
						onClick={ () => {
							if (window.zoomCampaignSdk) {
								window.zoomCampaignSdk.open();
								window.zoomCampaignSdk.show();
								window.zoomCampaignSdk.on('close', () => window.zoomCampaignSdk.hide());
							}
						}
						}
						primaryText="Chat with us"
						style={ styles.item }
					/>
					: null,
				<WMMenuItem
					className="app-social-menu-phone"
					href={ support.phoneHref }
					primaryText={ support.phoneText }
					style={ styles.item }
				/>
			] }
			primaryText="Get Help"
			rightIcon={ <ArrowDropRight /> }
			style={ styles.item }
		/>
		<WMMenuItem
			className="app-social-menu-status-page"
			href="https://status.workmarket.com"
			primaryText="Status Page"
			style={ styles.item }
		/>
	</React.Fragment>
);

SupportMenuItems.propTypes = {
	support: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	useZendesk: PropTypes.bool
};

SupportMenuItems.defaultProps = {
	support: {},
	useZendesk: false
};

export default SupportMenuItems;
